<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :label="selectLabel"
    :value="value"
    @input="(commissionPlans) => $emit('input', commissionPlans)"
  >
    <template #option="commissionPlan">
      <div>{{ commissionPlan.name }}</div>
      <div class="font-size-sm text-secondary">
        {{ commissionPlan.user.name }}
      </div>
    </template>
  </v-select>
</template>
<script>
export default {
  name: 'CommissionPlansSelect',
  props: {
    value: Object,
    id: {
      type: String,
      default: 'commission-plan',
    },
    selectLabel: {
      type: String,
      default: 'name',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: String,
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.getCommissionPlans();
  },
  methods: {
    getCommissionPlans() {
      const params = {
        active: true,
        paginate: false,
      };
      this.$commissionPlansAPI
        .getCommissionPlans(params)
        .then((response) => {
          this.options = response.commissionPlans;
        });
    },
  },
};
</script>
